module.exports = "/packs/images/general~a3ea5361ed0c41933f74c349c716810b.svg";